<template>
    <div>
        <v-layout row wrap align-center class="my-3">
            <v-flex xs12 sm12>
                <v-card flat class="elevation-0 lighten-5">
                    <v-layout wrap>
                        <v-flex d-flex xs12 sm6>
                            <ProjectInstallation/>
                        </v-flex>
                        <v-flex d-flex xs12 sm6>
                            <ProjectCommercialConditions/>
                        </v-flex>
                        <v-flex d-flex xs12>
                            <ProjectContractRetail ref="formContatoRef"
                                v-on:validated="validated" 
                                v-on:reseted="reseted" 
                                v-on:validationreseted="validationreseted" 
                            />
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import ProjectInstallation from "./ProjectInstallation";
    import ProjectCommercialConditions from "./ProjectCommercialConditions";
    import ProjectContractRetail from "./ProjectContractRetail";

    export default {
        name: "ProjectCommercialInformation",
        components: {ProjectContractRetail, ProjectCommercialConditions, ProjectInstallation},        
        methods:{
            validate () {
                this.$refs.formContatoRef.validate();
            },
            reset () {
                this.$refs.formContatoRef.reset();
            },
            resetValidation () {
                this.$refs.formContatoRef.resetValidation();
            },
            validated(value){
                this.$emit("validated", value);
            },
            reseted(value){
                this.$emit("reseted", value);
            },
            validationreseted(value){
                this.$emit("validationreseted", value);
            }
        }
    }
</script>

<style scoped>
    /deep/.info-color {
        color: #021746;
    }

    .text-area-style.v-input .v-input__slot {
        border-radius: 0;
    }
</style>
